import { cva } from "class-variance-authority";

export { default as InputLabel } from "./InputLabel";
export const sizes = ["sm", "md", "lg", "xl", "2xl"];

export const variants = cva(
    ["font-medium", "block", "text-secondary", "select-none"],
    {
        variants: {
            size: {
                sm: ["text-style-xs"],
                md: ["text-style-sm"],
                lg: ["text-style-sm"],
                xl: ["text-style-sm"],
                "2xl": ["text-style-base"],
            },
        },
    }
);
